import CustomLoading from './component'

export default CustomLoading
